import { createSlice } from "@reduxjs/toolkit";

const switchSlice = createSlice({
  name: "switch",
  initialState: {
    active: false,
  },
  reducers: {
    toggleSwitch: (state) => {
      state.active = !state.active;
    },
  },
});

export const toggleSwitch = switchSlice.actions.toggleSwitch;
export default switchSlice.reducer;
